<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="fresh-seed-bag-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            <el-table-column
                prop="code"
                label="Program Code"
                min-width="85"
            />
            <el-table-column
                prop="title"
                label="Program Title"
                min-width="75"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
export default {
    props: {
        programList: {
            type: Array
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        programList: {
            immediate: true,
            handler() {
                this.tableData = this.programList;
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/GerminationBatch/GerminationBatchProgramSimpleTable.vue